module.exports = __webpack_public_path__ + "static/media/Speaker_Icon.502251e6.svg";